import gql from 'graphql-tag';

const INITIATE_SOS_CONNECT = gql`
  mutation($sosCode: String) {
    initiateSosSession(sosCode: $sosCode)
  }
`;
const INITIATE_ADHOC_PATCH_SCAN = gql`
  mutation($actionType: String, $input: AdhocPatchActionInput!) {
    runPatchActionForAssets(actionType: $actionType, input: $input) {
      status
      successCount
      failureCount
    }
  }
`;

const INITIATE_ADHOC_PATCH_SCAN_V2 = gql`
  mutation($input: SelectionInput!) {
    executeAssetPatchScanAction(input: $input)
  }
`;

export {
  INITIATE_SOS_CONNECT,
  INITIATE_ADHOC_PATCH_SCAN,
  INITIATE_ADHOC_PATCH_SCAN_V2
};
